export enum ProgressStepperSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}

export enum ProgressStepperVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  low = 'low',
  high = 'high'
}

export interface Step {
  index: number;
  classMap: {
    [key: string]: boolean;
  };
}

export type CssClassMap = { [className: string]: boolean };
